// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ivu-table td.demo-table-info-column-operating{background-color:#515a6e!important}", ""]);
// Exports
module.exports = exports;
